import { EmailVerificationRejectedInfo } from './EmailVerificationRejectedInfo';
import type { MessageConfig } from '../messageConfig.types';

type EmailVerificationAttributes = {
  status?: string;
  reason?: string;
};

const PENDING_REFRESH_SECONDS = 15 * 60;

const emailVerificationConfig: MessageConfig<EmailVerificationAttributes> = {
  messageId: 'email-verification',
  bannerTag: 'EMAIL_VERIFICATION_REJECTED',
  descriptionComponent: EmailVerificationRejectedInfo,
  type: 'account',
  severity: 'error',
  additionalAttributes: [
    {
      name: 'status',
      requireTranslate: false,
    },
    {
      name: 'reason',
      requireTranslate: false,
    },
  ],
  // Only the rejected status has copy today; pending is intentionally hidden until designed.
  shouldDisplay: (rawAdditionalAttributes) =>
    rawAdditionalAttributes?.status === 'rejected',
  // Pending status can change at any time on the admin side, so cached
  // messages are treated as stale after this many seconds and re-fetched.
  refreshAfterSeconds: (rawAdditionalAttributes) =>
    rawAdditionalAttributes?.status === 'pending'
      ? PENDING_REFRESH_SECONDS
      : undefined,
};

export default emailVerificationConfig;
